module.exports = __webpack_public_path__ + "static/media/LK_Digital Logo.81759819.png";